export default __webpack_public_path__ + "static/media/screen10.87e0399d.png";